'use strict';

export function maxHeight(selector) {
  const elements = document.querySelectorAll(selector);
  let height = 0;

  elements.forEach((el) => {
    el.removeAttribute('style')
    height = height < el.offsetHeight ? el.offsetHeight : height;
  });

  return height;
}
export function htmlNews(data, container) {
  data.forEach((item) => {
    let div = document.createElement('div');
    div.className = 'news-card';
    div.innerHTML = `<a href="${item.url}" class="news-card__picture">
      <img src="${item.img}" class="news-card__img" width="328" height="232" alt="${item.title}">
      <span class="visually-hidden">${item.title}</span>
    </a>
    <a href="${item.url}" class="news-card__title">${item.title}</a>
    <div class="info-row">
      <time class="info-row__date" datetime="${item.date.datetime}">${item.date.createdAt}</time>
      <a href="${item.category.url}" class="info-row__category">${item.category.title}</a>
      <span class="info-row__views">${item.views}</span>
    </div>`;

    container.append(div);
  });
}

export function htmlSearch(data, container) {
  container.innerHTML = '';
  data.forEach((item) => {
    let div = document.createElement('div');
    div.className = 'search-card';
    div.innerHTML = `<a href="${item.url}" class="search-card__picture">
      <picture>
        <source media="(min-width: 1050px)" srcset="${item.img_desktop}">
        <img src="${item.img_mobile}" class="search-card__img" width="96" height="72" alt="${item.title}">
      </picture>
      <span class="visually-hidden">${item.title}</span>
    </a>
    <a href="${item.url}" class="search-card__title">${item.title}</a>
    <div class="info-row search-card__info">
      <time class="info-row__date" datetime="${item.date.datetime}">${item.date.createdAt}</time>
      <a href="${item.category.url}" class="info-row__category">${item.category.title}</a>
      <span class="info-row__views">${item.views}</span>
    </div>`;

    container.append(div);
  });
}

export function slideUp(el, duration= 500) {
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.boxSizing = 'border-box';
  el.style.height = el.offsetHeight + 'px';
  el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  window.setTimeout( () => {
    el.style.display = 'none';
    el.style.removeProperty('height');
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
  }, duration);
}

export function slideDown(el, duration= 500) {
  el.style.removeProperty('display');
  let display = window.getComputedStyle(el).display;

  if(display === 'none') {
    display = 'block';
  }

  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.boxSizing = 'border-box';
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + 'ms';
  el.style.height = height + 'px';
  el.style.removeProperty('padding-top');
  el.style.removeProperty('padding-bottom');
  el.style.removeProperty('margin-top');
  el.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
  }, duration);
}

export function slideToggle(el, duration = 500) {
  if (window.getComputedStyle(el).display === 'none') {
    return slideDown(el, duration);
  } else {
    return slideUp(el, duration);
  }
}